export default function CircularCheckBox({ style, fill = "#262626" }) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6067 4.70457C21.6754 3.25166 19.3301 2.29923 16.747 2.05959C9.32304 1.37084 2.74639 6.83081 2.05764 14.2548C1.36889 21.6787 6.82886 28.2554 14.2528 28.9441C21.6768 29.6329 28.2534 24.1729 28.9422 16.749C29.0374 15.7223 29.0151 14.7118 28.8862 13.7309"
        stroke="#215DAA"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13.314 20.4215L8 14.8165C8 14.8165 8.99765 14.7189 10.271 14.8165C11.5444 14.9141 12.3 15.6318 12.3 15.6318L14.5 18C16.1425 16.2336 23.8357 9.11635 26 6.99666C28.1643 4.87697 30.0338 4.41121 31 5.39632C27.715 8.79325 17.7971 18.9132 16.4058 20.2176C15.0145 21.5221 13.7649 20.897 13.314 20.4215Z"
        fill="#215DAA"
      />
    </svg>
  );
}
